export default __webpack_public_path__ + "static/EcomChair-a92b8b0bc0f8f5c4e9ffece87864b7a1.mp4";